import { render, staticRenderFns } from "./NewDocumentFormatSelectorDialog.vue?vue&type=template&id=467cab42&scoped=true&"
import script from "./NewDocumentFormatSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentFormatSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NewDocumentFormatSelectorDialog.vue?vue&type=style&index=0&id=467cab42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467cab42",
  null
  
)

export default component.exports